<template>
    <div>
        <TimeSeriesChart
            v-if="typeChart === 'area'"
            :data="chartData"
            :zoom-key="zoomKey"
            :key="resizeDataKey"
            :metric="metric"
            :show-plot-line="showPlotLine"
        ></TimeSeriesChart>
        <RoseWindChart
            v-if="typeChart === 'rose'"
            :data="chartData"
            :key="resizeDataKey"
        ></RoseWindChart>
        <SplineChart
            v-if="typeChart === 'spline' && reverse === false"
            :data="chartData"
            :zoom-key="zoomKey"
            :key="resizeDataKey"
            :metric="metric"
            :show-plot-line="showPlotLine"
        ></SplineChart>
        <SplineChartDouble
            v-if="typeChart === 'spline-double' && reverse === false"
            :data="chartData"
            :zoom-key="zoomKey"
            :key="resizeDataKey"
            :metric="metric"
            :show-plot-line="showPlotLine"
        ></SplineChartDouble>
        <SplineReverseChart
            v-if="typeChart === 'spline' && reverse === true"
            :data="chartData"
            :zoom-key="zoomKey"
            :key="resizeDataKey"
            :metric="metric"
            :show-plot-line="showPlotLine"
        ></SplineReverseChart>
        <ColumnChart
            v-if="typeChart === 'column' && reverse === false"
            :data="chartData"
            :zoom-key="zoomKey"
            :key="resizeDataKey"
            :metric="metric"
        ></ColumnChart>
        <DamBackgroundChart
            v-if="typeChart === 'bubble' && reverse === false"
            :data="chartData"
            :key="resizeDataKey"
            :metric="metric"
            :show-plot-line="showPlotLine"
        ></DamBackgroundChart>
    </div>
</template>

<script>
    import TimeSeriesChart from "../shared/TimeSeriesChart";
    import RoseWindChart from "../shared/RoseWindChart";
    import SplineChart from "../shared/SplineChart";
    import SplineReverseChart from "../shared/SplineReverseChart";
    import SplineChartDouble from "../shared/SplineChartDouble";
    import ColumnChart from "../shared/ColumnChart";
    import DamBackgroundChart from "../shared/DamBackgroundChart";
    import {mapGetters} from "vuex";
    import {
        GET_GRID_VIEW
    } from "../../store/actions/sensors";

    export default {
        name: "ChartBooleanList",
        components: {
            TimeSeriesChart,
            RoseWindChart,
            SplineChart,
            SplineReverseChart,
            SplineChartDouble,
            ColumnChart,
            DamBackgroundChart,
        },
        computed: {
            ...mapGetters([ GET_GRID_VIEW]),
        },
        watch: {
            GET_GRID_VIEW() {
                this.resizeDataKey = + new Date();
            }
        },
        props: {
            typeChart: String,
            reverse: Boolean,
            chartData: Object,
            zoomKey: Number,
            resizeKey: [String, Number],
            metric: String,
            showPlotLine: Boolean
        },
        created() {
            this.resizeDataKey = this.resizeKey
        },
        data() {
            return {
                resizeDataKey: '',
            }
        },
    }
</script>

<style scoped>

</style>